import { createRouter, createWebHistory } from "vue-router";

const adminRoutes = [
  {
    name: "PermissionView",
    path: "permission/list",
    component: () => import("@/views/console/permission/PermissionView.vue"),
  },
  {
    name: "EditPermission",
    path: "permission/edit/:id",
    component: () => import("@/views/console/permission/EditPermission.vue"),
  },
  {
    name: "RoleView",
    path: "role/list",
    component: () => import("@/views/console/role/RoleView.vue"),
  },
  {
    name: "EditRole",
    path: "role/edit/:id",
    component: () => import("@/views/console/role/EditRole.vue"),
  },
  {
    name: "SystemView",
    path: "system/list",
    component: () => import("@/views/console/system/SystemView.vue"),
  },
  {
    name: "EditSystem",
    path: "system/edit/:id",
    component: () => import("@/views/console/system/EditSystem.vue"),
  },
  {
    name: "AdminView",
    path: "admin/list",
    component: () => import("@/views/console/admin/AdminView.vue"),
  },
  {
    name: "EditAdmin",
    path: "admin/edit/:id",
    component: () => import("@/views/console/admin/EditAdmin.vue"),
  },
  {
    name: "IntegrationView",
    path: "integration/list",
    component: () => import("@/views/console/integration/IntegrationView.vue"),
  },
  {
    name: "EditIntegration",
    path: "integration/edit/:id",
    component: () => import("@/views/console/integration/EditIntegration.vue"),
  },
];

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
    redirect: "/console/permission/list",
  },
  {
    path: "/console",
    name: "AdminPage",
    component: () => import("@/views/console/AdminView.vue"),
    children: adminRoutes,
    redirect: "/console/permission/list",
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/NotFound.vue"),
  },
  {
    path: "/login",
    name: "LoginView",
    component: () => import("../views/LoginView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
